import { ModelRule } from 'src/containers/ProjectDiagram/types/data';

export const getNextRuleDuplicateName = (
  name: string,
  existingRules: Record<string, ModelRule>
) => {
  // collect the numeric suffixes from existing rules named `${name}_N`
  const suffixes = Object.values(existingRules)
    .filter((existingRule) => existingRule.name.startsWith(`${name}_`))
    .map((existingRule) => {
      // regex to get the number after the last _
      const lastNumMatch = existingRule.name.match(/(.*)_([0-9]+)$/);
      return lastNumMatch?.[2] ? parseInt(lastNumMatch[2]) : 0;
    });
  const highestSuffix = suffixes.length ? Math.max(...suffixes) : 0;

  return `${name}_${highestSuffix + 1}`;
};
